import api from './api';

const dashboardService = {
  // Obtener datos para curva S
  obtenerCurvaS: async (tipo = 'todos') => {
    try {
      const response = await api.get('/dashboard/curva-s', {
        params: { tipo }
      });
      return response.data;
    } catch (error) {
      console.error('Error al obtener curva S:', error);
      throw error;
    }
  },

  // Enviar reporte del dashboard por correo
  enviarReporte: async (emailDestino, datosProyecto, analisisPrecios, pdfBase64) => {
    try {
      const response = await api.post('/dashboard/enviar-reporte', {
        emailDestino,
        datosProyecto,
        analisisPrecios,
        pdfBase64
      }, {
        maxContentLength: 20 * 1024 * 1024,
        maxBodyLength: 20 * 1024 * 1024
      });
      if (response.status >= 400) {
        throw new Error(response.data?.error || 'Error al enviar el reporte');
      }
      return response.data;
    } catch (error) {
      console.error('Error al enviar reporte:', error);
      throw error;
    }
  }
};

export default dashboardService;
